"use strict";

var _interopRequireDefault = require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadView = exports.filterAsyncRouter = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _routers = require("@/router/routers");
var _Layout = _interopRequireDefault(require("@/views/layout/Layout"));
var permission = {
  state: {
    routers: _routers.constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = _routers.constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, asyncRouter) {
      var commit = _ref.commit;
      commit('SET_ROUTERS', asyncRouter);
    }
  }
};
var _filterAsyncRouter = exports.filterAsyncRouter = function filterAsyncRouter(routers) {
  // 遍历后台传来的路由字符串，转换为组件对象
  var accessedRouters = routers.filter(function (router) {
    if (router.path.indexOf('?') != -1) {
      router.query = urlToJson(router.path);
    }
    if (router.component) {
      if (router.component === 'Layout') {
        // Layout组件特殊处理
        router.component = _Layout.default;
      } else {
        var component = router.component;
        router.component = loadView(component);
      }
    }
    if (router.children && router.children.length) {
      router.children = _filterAsyncRouter(router.children);
    }
    // console.info('accessedRouters', router)
    return true;
  });
  return accessedRouters;
};
function urlToJson(url) {
  // 1. 截取 URL 中 ? 后的 query 部分（无参数则返回空对象）
  var queryStr = url.split('?')[1] || '';
  if (!queryStr) return {};

  // 2. 分割参数（& 分隔），遍历解析为键值对
  var jsonObj = {};
  queryStr.split('&').forEach(function (item) {
    // 处理 key=value 格式（兼容空值，如 isNew=、name=）
    var _item$split = item.split('='),
      _item$split2 = (0, _slicedToArray2.default)(_item$split, 2),
      key = _item$split2[0],
      value = _item$split2[1];
    if (key) {
      // 解码 URL 编码（如空格、中文），并处理值类型
      var decodedValue = decodeURIComponent(value || '');
      // 自动转换数字/布尔值（可选，根据需求）
      if (/^\d+$/.test(decodedValue)) {
        jsonObj[key] = Number(decodedValue); // 数字
      } else if (decodedValue === 'true' || decodedValue === 'false') {
        jsonObj[key] = decodedValue === 'true'; // 布尔值
      } else if (decodedValue === 'null') {
        jsonObj[key] = null; // null
      } else {
        jsonObj[key] = decodedValue; // 字符串
      }
    }
  });
  return jsonObj;
}

// export const loadView = (view) => { // 路由懒加载
//   return () => import(`@/views/${view}`)
// }
var loadView = exports.loadView = function loadView(view) {
  return function (resolve) {
    return require(["@/views/".concat(view)], resolve);
  };
};
var _default = exports.default = permission;